export type Endpoints = {
  createMembership: string;
  getConfirmation: string;
  getNewMembershipInfo: string;
  getJoinInitInfo: string;
  validateNationalToken: string;
  submitNewJoinFormData: string;
  checkMembershipStatus: string;
  getPaymentManifest: string;
  paymentsApi: string;
  registerAccount: string;
  getNewBusinessCost: string;
  getMembershipContent: string;
  encryptAnalytics: string;
  getPartnerEnrollmentStatus: string;
  getPartnerEligibility: string;
  postPartnerEnrollment: string;
  updateCache: string;
};

export enum Environments {
  dev1 = 'dev1',
  dev2 = 'dev2',
  dev = 'dev',
  qa1 = 'qa1',
  qa2 = 'qa2',
  qa = 'qa',
  uat1 = 'uat1',
  uat2 = 'uat2',
  uat = 'uat',
  stage = 'stg',
  prod = 'prod',
}

const endpointPath = {
  createMembership: '/membership-newjoin/newjoin/create-membership',
  getConfirmation: '/membership-newjoin/newjoin/newjoin-get-confirmation',
  getNewMembershipInfo: '/membership-newjoin/newjoin/new-membership-info',
  getJoinInitInfo: '/membership-newjoin/newjoin/newjoin-init',
  validateNationalToken: '/join/validate-token',
  submitNewJoinFormData: '/membership-newjoin/newjoin/validate-member',
  checkMembershipStatus: '/membership-newjoin/newjoin/membership-status',
  getPaymentManifest: '/membership-newjoin/newjoin/new-join-manifest',
  paymentsApi: '/payments',
  registerAccountApi: '/membership-newjoin/newjoin/register-account',
  getNewBusinessCost: '/membership-newjoin/newjoin/calculate-new-business-cost',
  getMembershipContent: '/membership-newjoin/newjoin/new-join-get-content',
  encryptAnalytics: '/membership-newjoin/newjoin/encrypt-analytics',
  getPartnerEligibility: '/membership-newjoin/newjoin/partner-eligibility',
  getPartnerEnrollmentStatus: '/membership-newjoin/newjoin/get-partner-enrollment-status',
  postPartnerEnrollment: '/membership-newjoin/newjoin/partner-enrollment',
  updateCache: '/membership-newjoin/newjoin/cache',
};

export const getLogEnvironmentFromHost = (hostname: string): string => {
  if (hostname.search('localhost') > -1) {
    return 'localhost';
  } else {
    if (hostname.startsWith('appdev1') || hostname.startsWith('app.dev') || hostname.startsWith('appdev2')) {
      return 'dev';
    } else if (hostname.startsWith('appqa1') || hostname.startsWith('app.qa') || hostname.startsWith('appqa2')) {
      return 'qa';
    } else if (hostname.startsWith('appuat1') || hostname.startsWith('app.uat') || hostname.startsWith('appuat2')) {
      return 'uat';
    } else if (hostname.startsWith('appstage') || hostname.startsWith('app.stage')) {
      return 'stage';
    } else if (hostname.startsWith('app.')) {
      return 'prod';
    } else {
      return 'unknown';
    }
  }
};

export const getEnvironmentFromHost = (hostname: string): Environments => {
  if (hostname.search('localhost') > -1) {
    return Environments.dev1;
  } else {
    if (hostname.startsWith('appdev1') || hostname.startsWith('app.dev')) {
      return Environments.dev1;
    } else if (hostname.startsWith('appdev2')) {
      return Environments.dev2;
    } else if (hostname.startsWith('appqa1') || hostname.startsWith('app.qa')) {
      return Environments.qa1;
    } else if (hostname.startsWith('appqa2')) {
      return Environments.qa2;
    } else if (hostname.startsWith('appuat1') || hostname.startsWith('app.uat')) {
      return Environments.uat1;
    } else if (hostname.startsWith('appuat2')) {
      return Environments.uat2;
    } else if (hostname.startsWith('appstage') || hostname.startsWith('app.stage')) {
      return Environments.stage;
    } else if (hostname.startsWith('app.')) {
      return Environments.prod;
    } else {
      return Environments.dev1;
    }
  }
};

export const getCommonEnvironmentFromHost = (hostname: string): Environments => {
  if (hostname.search('localhost') > -1) {
    return Environments.dev;
  } else {
    if (hostname.startsWith('appdev1') || hostname.startsWith('app.dev') || hostname.startsWith('appdev2')) {
      return Environments.dev;
    } else if (hostname.startsWith('appqa1') || hostname.startsWith('app.qa') || hostname.startsWith('appqa2')) {
      return Environments.qa;
    } else if (hostname.startsWith('appuat1') || hostname.startsWith('app.uat') || hostname.startsWith('appuat2')) {
      return Environments.uat;
    } else if (hostname.startsWith('appstage') || hostname.startsWith('app.stage')) {
      return Environments.stage;
    } else if (hostname.startsWith('app.')) {
      return Environments.prod;
    } else {
      return Environments.dev;
    }
  }
};

export const getApiDomain = (env: Environments): string => {
  if (env === Environments.prod) {
    return `api.ace.aaa.com`;
  } else {
    return `api${env}.ace.aaa.com`;
  }
};

const commonEnvMap: { [key in Environments]: Environments } = {
  [Environments.dev]: Environments.dev,
  [Environments.dev1]: Environments.dev,
  [Environments.dev2]: Environments.dev,
  [Environments.qa]: Environments.qa,
  [Environments.qa1]: Environments.qa,
  [Environments.qa2]: Environments.qa,
  [Environments.uat]: Environments.uat,
  [Environments.uat1]: Environments.uat,
  [Environments.uat2]: Environments.uat,
  [Environments.stage]: Environments.stage,
  [Environments.prod]: Environments.prod,
};

export const getCommonApiDomain = (env: Environments): string => {
  if (env === Environments.prod) {
    return `common.api.ace.aaa.com`; //@TODO: confirm prod api domain!
  } else {
    if (process.env.REACT_APP_SOURCES === 'remote' && process.env.REACT_APP_ENV !== undefined) {
      return `common.api.${process.env.REACT_APP_ENV}.ace.aaa.com`;
    } else return `common.api.${commonEnvMap[env]}.ace.aaa.com`;
  }
};
/*
export const getApiDomain = (env: Environments, stagged: boolean = false): string => {
  if (env === Environments.prod) {
    return `api.ace.aaa.com`;
  } else {
    if (env === Environments.stage) {
      if (stagged) {
        return `api${Environments.stage}.ace.aaa.com`;
      } else {
        return `api${Environments.prod}.ace.aaa.com`;
      }
    } else {
      if (stagged) {
        return `api${Environments.uat1}.ace.aaa.com`; //for now
      } else {
        return `api${env}.ace.aaa.com`;
      }
    }
  }
};
*/
export const getEndpoints = (hostname: string): Endpoints => {
  const env = getEnvironmentFromHost(hostname);

  const _endpoints: Endpoints = {
    createMembership: `https://${getCommonApiDomain(env)}${endpointPath.createMembership}`,
    getConfirmation: `https://${getCommonApiDomain(env)}${endpointPath.getConfirmation}`,
    getNewMembershipInfo: `https://${getCommonApiDomain(env)}${endpointPath.getNewMembershipInfo}`,
    getJoinInitInfo: `https://${getCommonApiDomain(env)}${endpointPath.getJoinInitInfo}`,
    validateNationalToken: `https://${getApiDomain(env)}${endpointPath.validateNationalToken}`,
    submitNewJoinFormData: `https://${getCommonApiDomain(env)}${endpointPath.submitNewJoinFormData}`,
    getPaymentManifest: `https://${getCommonApiDomain(env)}${endpointPath.getPaymentManifest}`,
    checkMembershipStatus: `https://${getCommonApiDomain(env)}${endpointPath.checkMembershipStatus}`,
    paymentsApi: `https://${getApiDomain(env)}${endpointPath.paymentsApi}`,
    registerAccount: `https://${getCommonApiDomain(env)}${endpointPath.registerAccountApi}`,
    getNewBusinessCost: `https://${getCommonApiDomain(env)}${endpointPath.getNewBusinessCost}`,
    getMembershipContent: `https://${getCommonApiDomain(env)}${endpointPath.getMembershipContent}`,
    encryptAnalytics: `https://${getCommonApiDomain(env)}${endpointPath.encryptAnalytics}`,
    getPartnerEnrollmentStatus: `https://${getCommonApiDomain(env)}${endpointPath.getPartnerEnrollmentStatus}`,
    getPartnerEligibility: `https://${getCommonApiDomain(env)}${endpointPath.getPartnerEligibility}`,
    postPartnerEnrollment: `https://${getCommonApiDomain(env)}${endpointPath.postPartnerEnrollment}`,
    updateCache: `https://${getCommonApiDomain(env)}${endpointPath.updateCache}`,
  };
  return _endpoints;
};

export const endpoints = getEndpoints(window.location.hostname);
